// extracted by mini-css-extract-plugin
module.exports = {"bodytext":"corps-module--bodytext--3Xn_h"};